import React from 'react';
import { I18n } from '@fiverr-private/fiverr_context';
import './index.scss';

const Footer = () => {

    const FOOTER_ITEMS = [
        'first_box',
        'second_box',
        'third_box'
    ];

    return (
        <footer>
            <ul className="footer-wrapper max-width-container equal-padding">
                {FOOTER_ITEMS.map((item) => (
                    <li key={item}>
                        <h3><I18n k={`category_page.footer.${item}.title`}/> <b><I18n k={`category_page.footer.${item}.title_bold`}/></b></h3>
                        <I18n k={`category_page.footer.${item}.text`}/>
                    </li>
                ))}
            </ul>
        </footer>
    );
};

export default Footer;
